"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FacilityIcon = _interopRequireDefault(require("../FacilityIcon"));

var FacilitiesItem = function FacilitiesItem(_ref) {
  var children = _ref.children,
      icon = _ref.icon;
  return /*#__PURE__*/_react["default"].createElement(StyledFacilitiesItem, null, /*#__PURE__*/_react["default"].createElement(StyledFacilityIcon, {
    type: icon
  }), /*#__PURE__*/_react["default"].createElement(StyledLabel, null, children));
};

var StyledFacilitiesItem = _styledComponents["default"].li.withConfig({
  displayName: "FacilitiesItem__StyledFacilitiesItem",
  componentId: "sc-lgbe5p-0"
})(["overflow:hidden;color:", ";margin-bottom:6px;display:flex;&::first-letter{text-transform:uppercase;}"], function (props) {
  return props.theme.colors.blackLight;
});

var StyledLabel = _styledComponents["default"].span.withConfig({
  displayName: "FacilitiesItem__StyledLabel",
  componentId: "sc-lgbe5p-1"
})(["overflow:hidden;text-overflow:ellipsis;align-self:center;"]);

var StyledFacilityIcon = (0, _styledComponents["default"])(_FacilityIcon["default"]).withConfig({
  displayName: "FacilitiesItem__StyledFacilityIcon",
  componentId: "sc-lgbe5p-2"
})(["margin-right:6px;flex-shrink:0;"]);

var _default = /*#__PURE__*/_react["default"].memo(FacilitiesItem);

exports["default"] = _default;